import { getTheme } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPIconButton, IPTooltipHost } from 'baseComponents';
import { IPDirectionalHint } from 'baseComponents/Dialog/IPDialog';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface ICollapsedResourcePanelProps {
  onShow: () => void;
}

const CollapsedResourcePanel = (props: ICollapsedResourcePanelProps) => {
  const { t } = useTranslation(['translation']);
  const appContext = useContext(AppContext);
  const theme = getTheme();

  const border = `1px solid ${appContext.useDarkMode ? theme.palette.neutralDark : theme.palette.neutralLighter}`;

  // Calculate bounds for tooltip positioning
  const left = appContext.isMobileView ? -33 : -23;
  const top = 25;

  return (
    <IPStack verticalFill onClick={() => props.onShow()} styles={{ root: { position: 'relative' } }}>
      <div style={{ position: 'absolute', left: left, top: top }}>
        <IPTooltipHost
          directionalHint={IPDirectionalHint.leftTopEdge}
          content={t('translation:ResourcePanel.Title')}
          calloutProps={{
            gapSpace: -left + 5,
          }}
        >
          <IPIconButton
            className="isoplanner-resourcepanel-open"
            iconProps={{ iconName: 'ChevronLeft' }}
            onClick={() => props.onShow()}
            styles={{
              root: {
                border: border,
                background: appContext.useDarkMode ? theme.palette.neutralDark : theme.palette.white,
              },
            }}
          />
        </IPTooltipHost>
      </div>
    </IPStack>
  );
};

export default CollapsedResourcePanel;
